import { Button, Col, Image, Modal, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import "./dashboard.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SaleStatistics from "./SaleStatistics/saleStatistics";
import InProgress from "./inprogress/inprogress";
import ChartPurchase from "./charpurchase/chartpurchase";
import Growth from "./growth/growth";
import Hero from "./hero/hero";
import { getSessionStorage, setSessionStorage } from "../../tools/services";

// TEMP: growth incentive card hidden until the business confirms it; set to true to show it again
const SHOW_GROWTH = false;

const POPUP_SEEN_KEY = "forcenotif";
// forced announcement: change the file name here for the next letter; shown once per session per file
const POPUP = {
	id: "aptel-10-years-festival-v3.jpg",
	title: "جشنواره تولد ۱۰ سالگی آپتل",
	src: process.env.PUBLIC_URL + "/assets/files/aptel-10-years-festival-v3.jpg",
};

const Dashboard = () => {
	const { _currentUser } = useSelector((state) => state?.another);
	const popup = POPUP;
	const [popupOpen, setPopupOpen] = useState(false);

	useEffect(() => {
		if (getSessionStorage(POPUP_SEEN_KEY) !== popup.id) setPopupOpen(true);
	}, [popup.id]);

	const closePopup = () => {
		setPopupOpen(false);
		setSessionStorage(POPUP_SEEN_KEY, popup.id);
	};

	return (
		<>
			<Content className="dashboard-page">
				<div className="dashboard-container">
					<Row gutter={[24, 24]}>
						<Col span={24}>
							<Hero user={_currentUser} popup={popup} onOpenPopup={() => setPopupOpen(true)} />
						</Col>
						{SHOW_GROWTH && (
							<Col span={24}>
								<Growth />
							</Col>
						)}
						<Col xl={12} xs={24}>
							<SaleStatistics />
						</Col>
						<Col xl={12} xs={24}>
							<InProgress />
						</Col>
						<Col span={24}>
							<ChartPurchase />
						</Col>
					</Row>
				</div>
			</Content>

			{popup && (
				<Modal
					open={popupOpen}
					title={popup.title}
					centered
					width="min(720px, 92vw)"
					className="dashboard-popup"
					onCancel={closePopup}
					footer={
						<Button type="primary" className="dashboard-popup-ok" onClick={closePopup}>
							متوجه شدم
						</Button>
					}>
					{/* click opens antd's full-screen preview with zoom/rotate */}
					<Image src={popup.src} alt={popup.title} width="100%" preview={{ mask: "برای بزرگ‌نمایی کلیک کنید" }} />
				</Modal>
			)}
		</>
	);
};

export default Dashboard;
